import React from "react";

import { Text, VStack } from "@chakra-ui/react";
import { DosageUnits, SupplementDosage } from "@henophess/types";

interface SupplementRecommendationsListProps {
  recommendations: SupplementDosage[];
}

const getUnitDisplay = (unit: DosageUnits | undefined, amount: number): string => {
  if (!unit) return "";
  switch (unit) {
    case DosageUnits.Pills:
      return amount === 1 ? "pill" : "pills";
    case DosageUnits.Mcg:
      return "mcg";
    case DosageUnits.Drops:
      return amount === 1 ? "drop" : "drops";
    case DosageUnits.Teaspoons:
      return amount === 1 ? "teaspoon" : "teaspoons";
    case DosageUnits.Milligrams:
      return "mg";
    default:
      return unit;
  }
};

export const SupplementRecommendationsList: React.FC<SupplementRecommendationsListProps> = ({ recommendations }) => {
  if (!recommendations || recommendations.length === 0) {
    return null;
  }

  return (
    <VStack align="stretch" spacing={2}>
      {recommendations.map((rec, index) => (
        <Text key={index} fontSize="md">
          {rec.supplement}: {rec.amount} {getUnitDisplay(rec.dosageUnit, rec.amount || 0)} per day
        </Text>
      ))}
    </VStack>
  );
};
